import { getApiConfig } from "../authHelper"

import { post } from "../api_helper"
import * as url from "../url_helper"

export const loginUser = data => {
  data["platform"] = "web"
  data["client"] = "admin"
  return post(url.LOGIN, data)
}
